import React from 'react';
import './App.css';

import Language from './components/language.js'
import Navbar from './components/navbar'
import Footer from './components/footer'

import Home from './pages/home'
import Research from './pages/research'
import Members from './pages/members'
import Publications from './pages/publications'
import Contact from './pages/contact'
import Professor from './pages/professor'


import {BrowserRouter as Router, Switch, Route} from "react-router-dom"

const navbarStyle={
  position: '-webkit-sticky',
  position: 'sticky',
  top: '0',
  zIndex: '5',
}
 
function App() {
  return (
    <Router>
      <div>
        <Language />
        <div style={navbarStyle}>
          <Navbar  />
        </div>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/research" exact component={Research} />
          <Route path="/members" exact component={Members} />
          <Route path="/publications" exact component={Publications} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/professor" exact component={Professor} />
        </Switch>

        <Footer />
      </div>
    </Router>
    
  );
}

export default App;
